import React from 'react';

import { Table } from 'react-bootstrap';
import moment from 'moment';
import uniqueId from 'lodash/uniqueId';
import styled from 'styled-components';

import { CDT } from '../../infrastructure/constants/common';
import Sorter from '../utils/Sorting/Sorter';
import { isMobileResolution } from '../../infrastructure/utils/common';
import { getConfig } from '../../config';

import RnrsListMobile from './RnrsListMobile';

const StyledResponseButton = styled.button`
  min-width: 90px;
`;

const RnrsList = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  rnrs,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  activeSort,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  changeSort,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setReviewToResponse,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  changeReviewVisibility,
}) => {
  const onRowClick = id => {
    const config = getConfig();
    const url = `${config.batchAdminURL}/experiences/${id}`;
    window.open(url, '_self');
  };

  const getFormattedDateSubmitted = item =>
    moment(item.createdAt).tz(CDT).format('MM/DD/YY hh:mm A z');

  const onResponseClick = (event, review) => {
    event.stopPropagation();
    setReviewToResponse(review);
  };

  const onChangeReviewVisibility = (event, item) => {
    event.stopPropagation();
    changeReviewVisibility(item);
  };

  if (isMobileResolution()) {
    return (
      <RnrsListMobile
        rnrs={rnrs}
        getFormattedDateSubmitted={getFormattedDateSubmitted}
        onRowClick={onRowClick}
      />
    );
  }

  return (
    <div>
      <Table hover>
        <thead>
          <tr>
            <th onClick={() => changeSort('productId')}>
              Product ID
              <Sorter activeSort={activeSort} name='productId' />
            </th>
            <th>Featured</th>
            <th onClick={() => changeSort('rating')}>
              Rating
              <Sorter activeSort={activeSort} name='rating' />
            </th>
            <th onClick={() => changeSort('review')}>
              Review
              <Sorter activeSort={activeSort} name='review' />
            </th>
            <th onClick={() => changeSort('vendorReview')}>
              Vendor Feedback
              <Sorter activeSort={activeSort} name='vendorReview' />
            </th>
            <th>User ID</th>
            <th onClick={() => changeSort('createdAt')}>
              Date Submitted
              <Sorter activeSort={activeSort} name='createdAt' />
            </th>
            <th />
            <th />
          </tr>
        </thead>
        <tbody>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {rnrs.map(item => {
            const uId = uniqueId(item.productId);
            return (
              <tr key={uId} onClick={() => onRowClick(item.productId)}>
                <td>{item.productId}</td>
                <td>{item.featured ? 'yes' : 'no'}</td>
                <td>{item.rating}</td>
                <td>{item.review}</td>
                <td>{item.vendorReview}</td>
                <td>{item.userId}</td>
                <td>{getFormattedDateSubmitted(item)}</td>
                <td>
                  <StyledResponseButton
                    type='button'
                    className={
                      item.adminResponse
                        ? 'btn btn-secondary'
                        : 'btn btn-primary'
                    }
                    onClick={event => onResponseClick(event, item)}
                  >
                    {item.adminResponse ? 'Edit' : 'Respond'}
                  </StyledResponseButton>
                </td>
                <td>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={event => onChangeReviewVisibility(event, item)}
                  >
                    {item.hidden ? 'Show Review' : 'Hide Review'}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default RnrsList;
